module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~#throughNotifications #throughNotificationsContainer #notices":{"handleDom.reconnect.target":[{"value":".reconnect","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~#throughNotifications #throughNotificationsContainer #notices","_fox_":1}],"handleDom.reconnect.event":[{"value":"click","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~#throughNotifications #throughNotificationsContainer #notices","_fox_":1}],"handleDom.reconnect.callback":[{"value":function (argument) {
fox.wom.selectFirst('@root #offlineChecker').checkConnectionStatus();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~#throughNotifications #throughNotificationsContainer #notices","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/options/root/throughNotifications.js
// module id = 222
// module chunks = 2